import { render, staticRenderFns } from "./FullPageLoader.vue?vue&type=template&id=0105dd21&"
import script from "./FullPageLoader.vue?vue&type=script&lang=js&"
export * from "./FullPageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0105dd21')) {
      api.createRecord('0105dd21', component.options)
    } else {
      api.reload('0105dd21', component.options)
    }
    module.hot.accept("./FullPageLoader.vue?vue&type=template&id=0105dd21&", function () {
      api.rerender('0105dd21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FullPageLoader.vue"
export default component.exports